import React, { FC, PropsWithChildren, useCallback } from 'react';
import { useLocalStorage } from 'src/helpers/useLocalStorage';
import { BufferItemType, FormBuilderBufferContext } from './formBuilderBuffer.context';

export const FormBuilderBufferContextProvider: FC<PropsWithChildren> = (props) => {
  const [buffer, setBuffer] = useLocalStorage<BufferItemType[]>('Buffer', []);
  const addToBuffer = useCallback(
    (nodeTree: BufferItemType) => {
      setBuffer((state) => [...state, nodeTree]);
    },
    [setBuffer],
  );
  const removeFromBuffer = useCallback(
    (name: string) => {
      setBuffer((state) => state.filter((x) => x.name !== name));
    },
    [setBuffer],
  );

  return (
    <FormBuilderBufferContext.Provider
      value={{
        buffer,
        addToBuffer,
        removeFromBuffer,
      }}
    >
      {props.children}
    </FormBuilderBufferContext.Provider>
  );
};
